import queryString from "query-string";
import { Endpoints } from "@constants";
import * as T from "@types";

export class Api {
  static accessToken: string;

  static init(options: T.ApiOpts) {
    Api.accessToken = options.accessToken;
  }

  static async getAudio({ id, audioId }: T.GetAudioParams) {
    return await Api.request({
      responseType: "blob",
      endpoint: "getAudio",
      method: "GET",
      pathParams: { id, audioId }
    });
  }

  static async getRadioStartup() {
    return await Api.request({ endpoint: "getRadioStartUp", method: "GET" });
  }

  static async request({
    responseType = "json",
    endpoint,
    method,
    body = {},
    pathParams = {},
    queryParams = {}
  }: T.RequestParams) {
    let response;
    try {
      const append = Object.keys(queryParams).length > 0 ? `?${queryString.stringify(queryParams)}` : ``;
      response = await fetch(Api.endpoint(endpoint, pathParams) + append, {
        method,
        headers: Api.getHeaders(),
        ...(Object.keys(body).length > 0 ? { body: JSON.stringify(body) } : {})
      });
    } catch (e) {
      console.error({ apiRequestError: e });
      throw e;
    }

    if (response?.ok) {
      const data = responseType === "json" ? await response.json() : await response.blob();
      return data;
    } else {
      return null;
    }
  }

  static writeAccessToken(accessToken) {
    Api.accessToken = accessToken;
  }

  static readAccessToken() {
    return Api.accessToken;
  }

  static endpoint(endpoint: keyof typeof Endpoints, pathParams?: T.RequestParams["pathParams"], hostName?: string) {
    if (!hostName) {
      hostName = process.env.API_HOST;
    }
    let endpointUri = Endpoints[endpoint];
    if (Object.keys(pathParams).length > 0) {
      Object.entries(pathParams).forEach(([key, value]) => {
        endpointUri = endpointUri.replace(`:${key}`, String(value));
      });
    }
    return hostName + endpointUri;
  }

  static getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Api.accessToken}`
    };
  }
}
